/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown>, size: NonNullable<unknown> }} Mk_Desktop_RequirementsInputs */

const en_mk_desktop_requirements = /** @type {(inputs: Mk_Desktop_RequirementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} · about ${i?.size} · .tgz archive.`)
};

const id_mk_desktop_requirements = /** @type {(inputs: Mk_Desktop_RequirementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versi ${i?.version} · sekitar ${i?.size} · arsip .tgz.`)
};

/**
* | output |
* | --- |
* | "Version {version} · about {size} · .tgz archive." |
*
* @param {Mk_Desktop_RequirementsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_requirements = /** @type {((inputs: Mk_Desktop_RequirementsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_RequirementsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_requirements(inputs)
	return en_mk_desktop_requirements(inputs)
});